<template>
  <section>
       <header class="flex">
      <h3 >OUR ACCOMPLISHMENTS / COLLABLS / MEDIA</h3>
      <h1>In Talks...</h1>
      <img src="../../assets/underline.png" alt="">
      </header>

      <div class="logos">
          <img class="accomplishment"  src="../../assets/accomplishments1.png" alt="">
          <img class="accomplishment" src="../../assets/accomplishments2.png" alt="">
          <img class="accomplishment"  src="../../assets/accomplishments3.png" alt="">
          <img class="accomplishment" src="../../assets/accomplishments4.png" alt="">
          <img class="accomplishment" src="../../assets/accomplishments5.png" alt="">
          <img  class="accomplishment" src="../../assets/accomplishments6.png" alt="">
          <img class="accomplishment" src="../../assets/accomplishments7.png" alt="">
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.accomplishment{
    margin: 20px;
}
.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 220px;
    text-align: center;
    margin-top: 150px;
}
.logos{
        display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    justify-content:space-around;
    padding-top: 50px;
        flex-wrap: wrap;
    height: 402px;
}
h3{
    color: #791E94;
    font-weight: 450;
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #791E94;
}

@media(max-width : 1450px){
    .logos{
        justify-content: center;
        height: 664px;
    }
}

</style>